import nlJson from '../../lang/nl.json';
export const localizationConfig = {
    language: 'nl',
    vocabularies: {
        nl: { ...nlJson }
    }
};
